import { useAppContext } from "../appContext";
import { Element } from "react-scroll";
// Data
import { blogPostData } from "../data";
// Components
import { Button, Col, Container, Row } from "react-bootstrap";
import { Title } from "./globalStyledComponents";
import StyledCardBlogPosts from "./StyledCardBlogPosts";

export default function Blogs() {
  const { theme } = useAppContext();

  return (
    <Element name={"Blogs"} id="blogposts">
      <section className="section">
        <Container className="text-center">
          <Title>
            <h2>Blog Posts</h2>
            <div className="underline"></div>
          </Title>
          <Row xs={1} md={2} lg={3} className="g-4 justify-content-center row">
                {blogPostData.map(function ({
                  id,
                  name,
                  date,
                  link
                }) {
                  return (
                    <Col key={id}>
                      <StyledCardBlogPosts
                        name={name}
                        date={date}
                        url={link}
                      />
                    </Col>
                  );
                })}
              </Row>
        </Container>
      </section>
    </Element>
  );
}
